// import get from 'lodash/get';
import { handleError } from 'helper/rest';
import { client } from 'helper/axios';
// import { setCookie } from 'helper/cookie';
// import { parseJWT } from 'helper/jwt';
// import Swal from 'sweetalert2';
// import Color from 'constants/color.constants';

export const getCategoryTutorialAll = async ({ token, params } : any) => {
   try {
      return await client
         .get(`category_tutorial`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
            params,
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const getCategoryTutorialById = async ({ token, params } : any) => {
   try {
      return await client
         .get(`category_tutorial/${params?.id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const postCreateCategoryTutorial = async ({ token, params } : any) => {
   try {
      return await client
         .post(`category_tutorial`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};


export const putUpdateCategoryTutorial = async ({ token, params, id } : any) => {
   try {
      return await client
         .put(`category_tutorial/${id}`, params, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};

export const deleteCategoryTutorial = async ({ token, id } : any) => {
   try {
      return await client
         .delete(`category_tutorial/${id}`, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         })
         .then((response) => {
            return response;
         })
         .catch((error) => {
            const { response } = error;
            handleError(response);
            return response;
         });
   } catch (error) {
      console.error('error', error);
      return error;
   }
};
